export default function User_settings() {
return (
  <div className="container mt-5">

    <div
      className="p-5 rounded-4"
      style={{
        background: "rgba(255,255,255,0.03)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255,255,255,0.08)",
        color: "#fff",
        maxWidth: "750px"
      }}
    >

      {/* Header */}
      <div className="mb-4">
        <h2 className="fw-semibold mb-3">Promena korisničkih podataka</h2>

        <p style={{ color: "rgba(255,255,255,0.75)", lineHeight: "1.7" }}>
          Možete zatražiti izmenu svojih korisničkih podataka u bilo kom trenutku.
          Radi bezbednosti i zaštite vašeg naloga, izmene se vrše putem direktnog
          zahteva našem timu.
        </p>

        <p style={{ color: "rgba(255,255,255,0.75)", lineHeight: "1.7" }}>
          Za promenu podataka pozovite nas ili nas kontaktirajte putem email adrese:
        </p>
      </div>

      {/* Contact Info */}
      <div
        className="p-4 rounded-3"
        style={{
          background: "rgba(255,255,255,0.04)",
          border: "1px solid rgba(255,255,255,0.06)"
        }}
      >

        <div className="mb-3">
          <span style={{ fontSize: "14px", color: "rgba(255,255,255,0.6)" }}>
            Email podrška
          </span>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              color: "#60a5fa"
            }}
          >
            support@alphasolutions.com
          </div>
        </div>

        <div>
          <span style={{ fontSize: "14px", color: "rgba(255,255,255,0.6)" }}>
            Telefon
          </span>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              color: "#fff"
            }}
          >
            +381 63 8597131
          </div>
        </div>

      </div>

      {/* Footer note */}
      <div className="mt-4">
        <p style={{ color: "rgba(255,255,255,0.6)", fontSize: "14px" }}>
          Naš tim će obraditi vaš zahtev u najkraćem roku.
        </p>
      </div>

    </div>
  </div>
    );
}